

























import { Component, Vue, Emit } from 'vue-property-decorator';
import { patrolManagementServe } from '@/api/installServer';

@Component
export default class BindPatrolEquip extends Vue {
  private visible = false;
  private form: any = {
    type: '',
    pointId: '',
    patrolEquipId: '',
  };
  private bindRules: any = {};
  private patrolEquipList: any = [];
  private typeOptions: any = [
    {
      value: '1',
      label: '二维码',
    },
    {
      value: '2',
      label: '蓝牙',
    },
    {
      value: '3',
      label: '二维码+蓝牙',
    },
  ];

  /**
   * 关闭窗口
   * @Params
   * @return
   **/
  hideDialog() {
    this.form = {};
    this.resetForm();
    this.visible = false;
  }

  /**
   * 显示窗口
   */
  showDialog(data: any) {
    this.form.pointId = data.id;
    this.visible = true;
  }

  /**
   *【表单】表单重置
   * @Params
   * @return
   **/
  resetForm() {
    const formComponent: any = this.$refs['form'];
    formComponent.resetFields();
  }

  /**
   *【按钮】提交按钮点击
   * @Params
   * @return
   **/
  handleSubmitBtnClick() {
    // 检查巡检点是否被绑定
    this.checkPointBind();
  }

  /**
   * 检查巡检点是否被绑定
   */
  checkPointBind() {
    const arrObj = this.patrolEquipList;
    try {
      arrObj.forEach((item: any) => {
        if (item.id == this.form.patrolEquipId) {
          if (item.pointId !== '') {
            this.$confirm('该巡检设备已经被绑定,是否从原来绑定的巡检点上解除绑定，重新绑定现在的巡检点?', '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(() => {
                this.bindPatrolEquip();
              })
              .catch(() => {});
          } else {
            this.bindPatrolEquip();
          }
          throw new Error();
        }
      });
    } catch (e) {}
  }

  /**
   * 修改类型时，同时更新巡检点
   */
  async handleTypeChange() {
    try {
      await this.getPatorlEquipListByType();
    } catch (e) {}
  }

  /**
   * 【接口】根据类型获取巡检设备list
   */
  async getPatorlEquipListByType() {
    try {
      const res: any = await patrolManagementServe.getPatrolEquipAllData({
        type: this.form.type,
        paging: false,
      });
      if (res.code === '200') {
        this.patrolEquipList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【接口】绑定巡检设备
   */
  async bindPatrolEquip() {
    try {
      const res: any = await patrolManagementServe.bindPoint({
        pointId: this.form.pointId,
        patrolEquipId: this.form.patrolEquipId,
      });
      if (res.code === '200') {
        this.hideDialog();
        this.onResponse();
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 提交成功事件
   * @Params
   * @return
   **/
  @Emit('on-response')
  onResponse() {}
}
